// No-op: heading levels are managed via provide/inject, no global state to reset
export default defineNuxtPlugin(() => {})
